import get from 'lodash/get';
import { useQuery } from '@apollo/client/react';
import { AllAdminsDocument, type AllAdminsQuery } from 'graphql/generated/graphql';

const useGetAllAdmins = (): [AllAdminsQuery['allAdmins'], boolean] => {
  const { data, loading } = useQuery(AllAdminsDocument);

  const noAdmins: AllAdminsQuery['allAdmins'] = [];
  const admins = get(data, 'allAdmins', noAdmins);

  return [admins, loading];
};

export default useGetAllAdmins;
